/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */
export type ChirpVoid = {};

/**
 * Virtual record for map with known enum keys
 */
export type EnumMapReviewQuestionToString = {
  TITLE?: string;
  REVIEW?: string;
  FOR?: string;
  PROS?: string;
  CONS?: string;
  CUSTOMIZABLE?: string;
  FEEDBACK?: string;
};

/**
 * Virtual record for map with known enum keys
 */
export type EnumMapRatingAxisToInteger = {
  OVERALL?: number;
  USABILITY?: number;
  FUNCTIONALITY?: number;
  VALUE?: number;
  SUPPORT_DOCS?: number;
  PERFORMANCE?: number;
};

export type Industry =
  | 'ARCHITECTURE'
  | 'AUTOMOTIVE_TRANSPORT'
  | 'BANKING_FINANCIAL_SERVICES'
  | 'BUSINESS_SERVICES_GENERAL'
  | 'CONSTRUCTION_RENOVATION'
  | 'CONSULTING_ADVISORY'
  | 'CONSUMER_PRODUCTS'
  | 'CONSUMER_SERVICES'
  | 'DATA_PROCESSING_HOSTING'
  | 'ECOMMERCE'
  | 'EDUCATION'
  | 'ELECTRONICS'
  | 'ENERGY'
  | 'ENTERTAINMENT'
  | 'FINANCE_INSURANCE'
  | 'GOVERNMENT'
  | 'HEALTH'
  | 'HOSPITALITY'
  | 'LEGAL_SERVICES'
  | 'MANUFACTURING'
  | 'MARKETING_SERVICES'
  | 'MEDIA_PUBLISHING'
  | 'MEDICAL_WELLNESS'
  | 'NON_PROFIT'
  | 'OIL_GAS'
  | 'OTHER'
  | 'REAL_ESTATE'
  | 'RECRUITING_STAFFING'
  | 'RETAIL'
  | 'SHIPPING'
  | 'TECHNOLOGY_HARDWARE_STORAGE'
  | 'TECHNOLOGY_SOFTWARE'
  | 'TELECOM_MOBILE_COMMUNICATIONS'
  | 'TOURISM_TRAVEL'
  | 'TRANSPORTATION_STORAGE'
  | 'UTILITIES'
  | 'WASTE_MANAGEMENT'
  | unhandledEnumCase;

export type EmployeeSize =
  | 'RANGE_1'
  | 'RANGE_2_5'
  | 'RANGE_6_10'
  | 'RANGE_11_25'
  | 'RANGE_26_50'
  | 'RANGE_51_200'
  | 'RANGE_201_1000'
  | 'RANGE_1001_10000'
  | 'RANGE_10001_'
  | 'PREFER_NOT_TO_SAY'
  | unhandledEnumCase;

export type AppReviewability = {
  entityId: number;
  reviewabilityErrors: Default<ReviewabilityMessage[]>;
};

export type AppReviews = {
  entityId: number;
  offeringId?: number;
  reviews: Default<LegacyReviewResponse[]>;
  reviewabilityErrors: Default<ReviewabilityMessage[]>;
};

export type CheckReviewabilityByAppIdsRequest = { appIds: Default<number[]> };

export type CheckReviewabilityByAppIdsResponse = {
  reviewabilityByAppId: Default<Record<string, AppReviewability>>;
};

export type CheckReviewabilityRequest = {
  entityId: number;
  reviewType: ReviewType;
};

export type GenerateTitleError = {
  errorType: ComHubspotReviewsModelsAbstractGenerateTitleError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GenerateTitleRequest = {
  type: ReviewType;
  entityName: string;
  answers: Default<EnumMapReviewQuestionToString>;
  ratings: Default<EnumMapRatingAxisToInteger>;
};

export type GenerateTitleResponse = { title: string };

export type GetOverallStatsBatchRequest = {
  entityIds: Default<number[]>;
  reviewTypeName?: string;
  reviewType?: ReviewType;
  createdAfter?: number;
};

export type GetOverallStatsBatchResponse = {
  statsByEntityId: Default<Record<string, OverallStats>>;
};

export type GetOverallStatsRequest = {
  entityId: number;
  reviewType: ReviewType;
};

export type GetOverallStatsResponse = { stats: OverallStats };

export type GetOwnReviewsByAppIdsRequest = { appIds: Default<number[]> };

export type GetOwnReviewsByAppIdsResponse = {
  reviewsByAppId: Default<Record<string, AppReviews>>;
};

export type GetPrivateFeedbackError = {
  errorType: ComHubspotReviewsModelsAbstractGetPrivateFeedbackError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetPrivateFeedbackRequest = {
  entityId: number;
  reviewType: ReviewType;
  limit: Default<number>;
  offset: Default<number>;
  sort: Default<SortOrder>;
};

export type GetPrivateFeedbackResponse = {
  privateFeedback: Default<PrivateFeedback[]>;
  total: number;
};

export type GetReviewStatsBatchRequest = {
  entityIds: Default<number[]>;
  reviewType: ReviewType;
};

export type GetReviewStatsBatchResponse = {
  statsByEntityId: Default<Record<string, ReviewStats>>;
};

export type GetReviewStatsRequest = {
  entityId: number;
  reviewType: ReviewType;
};

export type GetReviewStatsResponse = { stats: ReviewStats };

export type GetReviewerDisplayNameResponse = { displayName: string };

export type GetSummaryError = {
  errorType: ComHubspotReviewsModelsAbstractGetSummaryError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type OverallStats = {
  count: number;
  average?: number;
  adjustedAverage?: number;
  distribution: Default<Record<string, number>>;
};

/**
 *  A review's private feedback: only the answers and ratings marked private in the schema, not the
 *  review's full public content.
 */
export type PrivateFeedback = {
  reviewId: number;
  createdAt: number;
  answers: Default<Record<string, string>>;
  ratings: Default<Record<string, number>>;
};

export type RatingAxisStats = {
  count: number;
  average?: number;
  adjustedAverage?: number;
  distribution: Default<Record<string, number>>;
};

export type Review = {
  id: number;
  legacyId?: number;
  entityId: number;
  entryId: number;
  entityVersion?: string;
  reviewType: ReviewType;
  archived: boolean;
  createdAt: number;
  helpfulCount: number;
  attributes: Default<LegacyReviewAttribute[]>;
  reviewerPortalId?: number;
  reviewerUserId?: number;
  reviewerEmployeeSize?: EmployeeSize;
  reviewerIndustry?: Industry;
  replies: Default<ReviewReply[]>;
  archivedReplies: Default<ReviewReply[]>;
  entryContent: string;
  originalLanguage?: string;
  originalEntryContent?: string;
  reviewerDisplayName?: string;
  reviewerCompanyName?: string;
  avatarUrl?: string;
  lastEditedAt?: number;
  showAvatar: Default<boolean>;
};

export type ReviewMutationError = {
  errorType: ComHubspotReviewsModelsAbstractReviewMutationError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ReviewReply = {
  replyId: number;
  legacyId?: number;
  entryId: number;
  userId: number;
  repliedAt: number;
  archived: boolean;
  entryContent: string;
  replierDisplayName?: string;
  avatarUrl?: string;
  companyName?: string;
  originalLanguage?: string;
  originalEntryContent?: string;
};

export type ReviewSort =
  | 'NEWEST'
  | 'OLDEST'
  | 'HIGHEST_OVERALL_RATING'
  | 'LOWEST_OVERALL_RATING'
  | 'MOST_HELPFUL'
  | 'RELEVANCE'
  | unhandledEnumCase;

export type ReviewStats = {
  statsByRatingField: Default<Record<string, RatingAxisStats>>;
};

export type ReviewSummaryRequest = {
  entityId: number;
  type: ReviewType;
  language: string;
};

export type ReviewSummaryResponse = { summary?: string; updatedAt?: number };

export type ReviewType =
  | 'APP'
  | 'PROFILE'
  | 'THEME'
  | 'MODULE'
  | 'ACADEMY_COURSE'
  | 'ACADEMY_LESSON'
  | 'ACADEMY_ON_THE_GO'
  | 'AGENT'
  | 'WORKFLOW_TEMPLATE'
  | unhandledEnumCase;

export type ReviewTypeError = {
  errorType: ComHubspotReviewsModelsAbstractReviewTypeError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ReviewabilityError = {
  errorType: ComHubspotReviewsModelsAbstractReviewabilityError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ReviewabilityMessage = {
  category: string;
  subCategory: string;
  message: string;
};

export type SearchReviewsError = {
  errorType: ComHubspotReviewsModelsAbstractSearchReviewsError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type SearchReviewsRequest = {
  search?: string;
  language: Default<string>;
  sortFields: Default<ReviewSort[]>;
  entityId?: number;
  reviewTypes: Default<string[]>;
  reviewTypesEnums: Default<ReviewType[]>;
  overallRating?: number;
  reviewerPortalId?: number;
  reviewerUserId?: number;
  employeeSizes?: EmployeeSizeFilter;
  industries?: IndustryFilter;
  tagFilters: Default<TagFilter[]>;
  limit: Default<number>;
  offset: Default<number>;
};

export type SearchReviewsResponse = {
  reviews: Default<Review[]>;
  total: number;
};

export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;

export namespace ComHubspotReviewsModelsAbstractGenerateTitleError {
  export type ErrorType =
    | 'INPUT_TOO_LONG'
    | 'INVALID_REQUEST'
    | 'MISSING_PORTAL_ID'
    | 'AI_ACCESS_DISABLED'
    | 'SERVICE_UNAVAILABLE'
    | unhandledEnumCase;
}

export namespace ComHubspotReviewsModelsAbstractGetPrivateFeedbackError {
  export type ErrorType =
    | 'INVALID_REQUEST'
    | 'NOT_FOUND'
    | 'FORBIDDEN'
    | unhandledEnumCase;
}

export namespace ComHubspotReviewsModelsAbstractGetSummaryError {
  export type ErrorType =
    | 'NOT_FOUND'
    | 'INVALID_ENUM'
    | 'INVALID_LANGUAGE'
    | 'UNEXPECTED_ERROR'
    | unhandledEnumCase;
}

export namespace ComHubspotReviewsModelsAbstractReviewMutationError {
  export type ErrorType =
    | 'NOT_FOUND'
    | 'ALREADY_EXISTS'
    | 'NOT_AUTHORIZED'
    | 'INVALID_REVIEW_TYPE'
    | 'MISSING_PORTAL_ID'
    | 'MISSING_USER_ID'
    | 'UNEXPECTED_ERROR'
    | 'REVIEWABILITY_FAILED'
    | unhandledEnumCase;
}

export namespace ComHubspotReviewsModelsAbstractReviewTypeError {
  export type ErrorType =
    | 'NOT_FOUND'
    | 'ALREADY_EXISTS'
    | 'UNEXPECTED_ERROR'
    | unhandledEnumCase;
}

export namespace ComHubspotReviewsModelsAbstractReviewabilityError {
  export type ErrorType =
    | 'MISSING_PORTAL_ID'
    | 'MISSING_USER_ID'
    | 'INVALID_REVIEW_TYPE'
    | 'NOT_FOUND'
    | 'UNEXPECTED_ERROR'
    | 'HUBSPOTTER_REVIEW'
    | 'SELF_REVIEW'
    | 'MAX_PORTAL_REVIEWS'
    | 'MAX_USER_REVIEWS'
    | 'PORTAL_TOO_YOUNG'
    | 'EMPTY_PORTAL'
    | 'DISALLOWED_PORTAL_TYPE'
    | 'TYPE_SPECIFIC_CHECK_FAILED'
    | 'PENDING_APPROVAL'
    | unhandledEnumCase;
}

export namespace ComHubspotReviewsModelsAbstractSearchReviewsError {
  export type ErrorType =
    | 'INVALID_REQUEST'
    | 'UNEXPECTED_ERROR'
    | unhandledEnumCase;
}

export type GetReviewEditabilityRequest = {
  reviewId?: number;
  legacyReviewId?: number;
};

export type ReviewEditability = {
  answersEditable: boolean;
  ratingsEditable: boolean;
  tagsEditable: boolean;
};

export type LegacyOriginalContent = {
  ratings: Default<Record<string, number>>;
  answers: Default<Record<string, string>>;
  tags: Default<Record<string, number[]>>;
};

export type LegacyReplyResponse = {
  id: number;
  legacyId?: number;
  repliedAt: number;
  reply: string;
  replierDisplayName: string;
  avatarUrl: string;
  companyName?: string;
};

export type LegacyReviewAttribute = {
  reviewId: number;
  userId: number;
  helpful: boolean;
};

export type LegacyReviewResponse = {
  id: number;
  reviewId?: number;
  legacyId: Default<number>;
  entityId?: number;
  reviewType?: ReviewType;
  archived: Default<boolean>;
  createdAt: number;
  lastEditedAt?: number;
  ratings: Default<Record<string, number>>;
  answers: Default<Record<string, string>>;
  tags: Default<Record<string, number[]>>;
  original?: LegacyOriginalContent;
  untranslated?: LegacyUntranslatedContent;
  replies: Default<LegacyReplyResponse[]>;
  archivedReplies: Default<LegacyReplyResponse[]>;
  listingName?: string;
  providerPortalId?: number;
  reviewerDisplayName: string;
  avatarUrl: string;
  showAvatar: Default<boolean>;
  attributes: Default<LegacyReviewAttribute[]>;
  entityVersion?: string;
  originalLanguage?: string;
  translated: Default<boolean>;
  reviewerData: LegacyReviewerData;
};

export type LegacyReviewerData = {
  userId?: number;
  portalId?: number;
  employees?: string;
  industry?: string;
  companyName?: string;
  showAvatar: Default<boolean>;
};

export type LegacySearchReviewsResponse = {
  reviews: Default<LegacyReviewResponse[]>;
  total: number;
};

export type LegacyUntranslatedContent = {
  answers: Default<Record<string, string>>;
  reply?: string;
  replies: Default<string[]>;
};

export type EmailToken = { key: string; displayName: string };

export type GetReviewRequestEmailTokensResponse = {
  tokens: Default<EmailToken[]>;
};

export type PreviewReviewRequestEmailError = {
  errorType: ComHubspotReviewsModelsNotificationsAbstractPreviewReviewRequestEmailError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type PreviewReviewRequestEmailRequest = {
  listingId: number;
  userId?: number;
  content: Default<Record<string, string>>;
};

export type PreviewReviewRequestEmailResponse = {
  subject: string;
  html: string;
};

export namespace ComHubspotReviewsModelsNotificationsAbstractPreviewReviewRequestEmailError {
  export type ErrorType =
    | 'FORBIDDEN'
    | 'INVALID_REQUEST'
    | 'TEMPLATE_UNAVAILABLE'
    | 'RENDER_FAILED'
    | unhandledEnumCase;
}

export type EmployeeSizeFilter = {
  values: Default<EmployeeSize[]>;
  clause: QueryClause;
};

export type IndustryFilter = {
  values: Default<Industry[]>;
  clause: QueryClause;
};

export type QueryClause = 'AND' | 'OR' | unhandledEnumCase;

export type TagFilter = {
  group: TagGroup;
  values: Default<number[]>;
  clause: QueryClause;
};

export type TagGroup =
  | 'CATALOG_SERVICES'
  | 'LIKE_FEEDBACK'
  | 'DISLIKE_FEEDBACK'
  | unhandledEnumCase;

export type GetReviewTagsResponse = { groups: Default<ReviewTagGroup[]> };

export type ReviewTagGroup = {
  group: string;
  values: Default<Record<string, number>>;
};

export type GetThemesError = {
  errorType: ComHubspotReviewsModelsThemesAbstractGetThemesError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetThemesRequest = {
  entityId: number;
  type: ReviewType;
  language: string;
};

export type GetThemesResponse = {
  themes: Default<ReviewTheme[]>;
  updatedAt?: number;
};

export type ReviewTheme = {
  label: string;
  positiveCount: number;
  negativeCount: number;
  excerpts: Default<ThemeExcerpt[]>;
};

export type ThemeExcerpt = {
  text: string;
  reviewId: number;
  sentiment: ThemeSentiment;
  highlightPhrases: Default<string[]>;
};

export type ThemeSentiment =
  | 'INVALID_ENUM'
  | 'POSITIVE'
  | 'NEGATIVE'
  | unhandledEnumCase;

export namespace ComHubspotReviewsModelsThemesAbstractGetThemesError {
  export type ErrorType =
    | 'INVALID_ENUM'
    | 'INVALID_LANGUAGE'
    | 'UNEXPECTED_ERROR'
    | unhandledEnumCase;
}

export type GenerateTitleRequestType = Requestify<GenerateTitleRequest>;
export type GenerateTitleResponseType = GenerateTitleResponse;
export type GenerateTitleErrorType = GenerateTitleError & HubspotMetadata;
export const generateTitleRpc: ChirpAvroRpcDetails<
  GenerateTitleRequestType,
  GenerateTitleResponseType,
  GenerateTitleErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'generateTitle',
  auth: 'app',
  fingerprint: 'fqdMoQlzJDzmxBCl8KDHlJG0DHPqwZAw',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSummaryRequestType = Requestify<ReviewSummaryRequest>;
export type GetSummaryResponseType = ReviewSummaryResponse;
export type GetSummaryErrorType = GetSummaryError & HubspotMetadata;
export const getSummaryRpc: ChirpAvroRpcDetails<
  GetSummaryRequestType,
  GetSummaryResponseType,
  GetSummaryErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getSummary',
  auth: 'app',
  fingerprint: 'w4ShM0OOxZaic1v6FGKGHm5znO6Jte-P',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetEditabilityRequestType = Requestify<GetReviewEditabilityRequest>;
export type GetEditabilityResponseType = ReviewEditability;
export type GetEditabilityErrorType = ReviewMutationError & HubspotMetadata;
export const getEditabilityRpc: ChirpAvroRpcDetails<
  GetEditabilityRequestType,
  GetEditabilityResponseType,
  GetEditabilityErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getEditability',
  auth: 'app',
  fingerprint: 'aTRGwrPgigzdtK6GeSw-g-dNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetThemesRequestType = Requestify<GetThemesRequest>;
export type GetThemesResponseType = GetThemesResponse;
export type GetThemesErrorType = GetThemesError & HubspotMetadata;
export const getThemesRpc: ChirpAvroRpcDetails<
  GetThemesRequestType,
  GetThemesResponseType,
  GetThemesErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getThemes',
  auth: 'app',
  fingerprint: 'fMDThFkFbqwnKDiSpQZsP-C6RBaWvYMU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SearchReviewsRequestType = Requestify<SearchReviewsRequest>;
export type SearchReviewsResponseType = SearchReviewsResponse;
export type SearchReviewsErrorType = SearchReviewsError & HubspotMetadata;
export const searchReviewsRpc: ChirpAvroRpcDetails<
  SearchReviewsRequestType,
  SearchReviewsResponseType,
  SearchReviewsErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'searchReviews',
  auth: 'app',
  fingerprint: '2zDvX7GKho9m3yklrJcXf-C7Y-r6etvU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SearchReviewsLegacyRequestType = Requestify<SearchReviewsRequest>;
export type SearchReviewsLegacyResponseType = LegacySearchReviewsResponse;
export type SearchReviewsLegacyErrorType = SearchReviewsError & HubspotMetadata;
export const searchReviewsLegacyRpc: ChirpAvroRpcDetails<
  SearchReviewsLegacyRequestType,
  SearchReviewsLegacyResponseType,
  SearchReviewsLegacyErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'searchReviewsLegacy',
  auth: 'app',
  fingerprint: '2zDvX7GKho_j9yFWkyrTmOC7Y-r6etvU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CheckReviewabilityRequestType =
  Requestify<CheckReviewabilityRequest>;
export type CheckReviewabilityResponseType = ChirpVoid;
export type CheckReviewabilityErrorType = ReviewabilityError & HubspotMetadata;
export const checkReviewabilityRpc: ChirpAvroRpcDetails<
  CheckReviewabilityRequestType,
  CheckReviewabilityResponseType,
  CheckReviewabilityErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'checkReviewability',
  auth: 'app',
  fingerprint: 'rK6Gz27x3T-OUe2e_r4XmdPzNCIu_Fnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CheckReviewabilityByAppIdsRequestType =
  Requestify<CheckReviewabilityByAppIdsRequest>;
export type CheckReviewabilityByAppIdsResponseType =
  CheckReviewabilityByAppIdsResponse;
export type CheckReviewabilityByAppIdsErrorType = ReviewabilityError &
  HubspotMetadata;
export const checkReviewabilityByAppIdsRpc: ChirpAvroRpcDetails<
  CheckReviewabilityByAppIdsRequestType,
  CheckReviewabilityByAppIdsResponseType,
  CheckReviewabilityByAppIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'checkReviewabilityByAppIds',
  auth: 'app',
  fingerprint: 'BsWryMa_oaZYRK7MDLUPdtPzNCIu_Fnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetOverallStatsRequestType = Requestify<GetOverallStatsRequest>;
export type GetOverallStatsResponseType = GetOverallStatsResponse;
export type GetOverallStatsErrorType = ReviewTypeError & HubspotMetadata;
export const getOverallStatsRpc: ChirpAvroRpcDetails<
  GetOverallStatsRequestType,
  GetOverallStatsResponseType,
  GetOverallStatsErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOverallStats',
  auth: 'app',
  fingerprint: 'Cd1r4NjxaRsq_MWw2l3YQbO_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetOverallStatsBatchRequestType =
  Requestify<GetOverallStatsBatchRequest>;
export type GetOverallStatsBatchResponseType = GetOverallStatsBatchResponse;
export type GetOverallStatsBatchErrorType = ReviewTypeError & HubspotMetadata;
export const getOverallStatsBatchRpc: ChirpAvroRpcDetails<
  GetOverallStatsBatchRequestType,
  GetOverallStatsBatchResponseType,
  GetOverallStatsBatchErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOverallStatsBatch',
  auth: 'app',
  fingerprint: 'V-Y68wXlE-cEZ_3SCaD797O_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetReviewStatsRequestType = Requestify<GetReviewStatsRequest>;
export type GetReviewStatsResponseType = GetReviewStatsResponse;
export type GetReviewStatsErrorType = ReviewTypeError & HubspotMetadata;
export const getReviewStatsRpc: ChirpAvroRpcDetails<
  GetReviewStatsRequestType,
  GetReviewStatsResponseType,
  GetReviewStatsErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewStats',
  auth: 'app',
  fingerprint: '7LR9ynyuLvIfECQPffDsSrO_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetReviewStatsBatchRequestType =
  Requestify<GetReviewStatsBatchRequest>;
export type GetReviewStatsBatchResponseType = GetReviewStatsBatchResponse;
export type GetReviewStatsBatchErrorType = ReviewTypeError & HubspotMetadata;
export const getReviewStatsBatchRpc: ChirpAvroRpcDetails<
  GetReviewStatsBatchRequestType,
  GetReviewStatsBatchResponseType,
  GetReviewStatsBatchErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewStatsBatch',
  auth: 'app',
  fingerprint: 'cGiw2jBhtoUCzEvvvSk1KbO_C9QUba5Y',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPrivateFeedbackRequestType =
  Requestify<GetPrivateFeedbackRequest>;
export type GetPrivateFeedbackResponseType = GetPrivateFeedbackResponse;
export type GetPrivateFeedbackErrorType = GetPrivateFeedbackError &
  HubspotMetadata;
export const getPrivateFeedbackRpc: ChirpAvroRpcDetails<
  GetPrivateFeedbackRequestType,
  GetPrivateFeedbackResponseType,
  GetPrivateFeedbackErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getPrivateFeedback',
  auth: 'app',
  fingerprint: 'cBpM1fNtfbVb1GUijSNljrF3tT30u0iZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetReviewRequestEmailTokensResponseType =
  GetReviewRequestEmailTokensResponse;
export type GetReviewRequestEmailTokensErrorType = EmptyError & HubspotMetadata;
export const getReviewRequestEmailTokensRpc: ChirpAvroRpcDetails<
  undefined,
  GetReviewRequestEmailTokensResponseType,
  GetReviewRequestEmailTokensErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewRequestEmailTokens',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACINleg96NDbZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PreviewReviewRequestEmailRequestType =
  Requestify<PreviewReviewRequestEmailRequest>;
export type PreviewReviewRequestEmailResponseType =
  PreviewReviewRequestEmailResponse;
export type PreviewReviewRequestEmailErrorType =
  PreviewReviewRequestEmailError & HubspotMetadata;
export const previewReviewRequestEmailRpc: ChirpAvroRpcDetails<
  PreviewReviewRequestEmailRequestType,
  PreviewReviewRequestEmailResponseType,
  PreviewReviewRequestEmailErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'previewReviewRequestEmail',
  auth: 'app',
  fingerprint: 'FDxdRcQ_jaCMsJmj-C-KVfPdMdEVFeQc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetReviewTagsResponseType = GetReviewTagsResponse;
export type GetReviewTagsErrorType = EmptyError & HubspotMetadata;
export const getReviewTagsRpc: ChirpAvroRpcDetails<
  undefined,
  GetReviewTagsResponseType,
  GetReviewTagsErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewTags',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABx42BfnpCCI5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetReviewerDisplayNameResponseType = GetReviewerDisplayNameResponse;
export type GetReviewerDisplayNameErrorType = ReviewMutationError &
  HubspotMetadata;
export const getReviewerDisplayNameRpc: ChirpAvroRpcDetails<
  undefined,
  GetReviewerDisplayNameResponseType,
  GetReviewerDisplayNameErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getReviewerDisplayName',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACqMt9eT6GjPedNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetOwnReviewsByAppIdsRequestType =
  Requestify<GetOwnReviewsByAppIdsRequest>;
export type GetOwnReviewsByAppIdsResponseType = GetOwnReviewsByAppIdsResponse;
export type GetOwnReviewsByAppIdsErrorType = ReviewMutationError &
  HubspotMetadata;
export const getOwnReviewsByAppIdsRpc: ChirpAvroRpcDetails<
  GetOwnReviewsByAppIdsRequestType,
  GetOwnReviewsByAppIdsResponseType,
  GetOwnReviewsByAppIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getOwnReviewsByAppIds',
  auth: 'app',
  fingerprint: 'A3IiYp_GBBsMeM23VjrYtedNEFbj_dt7',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
